import { Component, Input, OnInit } from '@angular/core';
import { FlyingclubSummary } from '../models/flyingclub-summary.model';
import {BusinessManagerService} from '../../shared/user/business-manager.service';

@Component({
  selector: 'app-flyingclub-listing',
  templateUrl: './flyingclub-listing.component.html',
  styleUrls: ['./flyingclub-listing.component.scss']
})
export class FlyingclubListingComponent implements OnInit {
  isFlightDeckAdmin = false;
  constructor( private businessManagerService: BusinessManagerService ) { }

  @Input() flyingClubs: FlyingclubSummary[];

  get sortedClubs(): FlyingclubSummary[] {
    if (!this.isFlightDeckAdmin) {
      return this.flyingClubs.filter(fc => !fc.hideBusiness)
        .filter(fc =>  !fc.notApproved)
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
    }
    return this.flyingClubs
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
  }
  async ngOnInit() {
    this.isFlightDeckAdmin = await this.businessManagerService.isFlightDeckAdmin();
  }

}
